module.exports = __webpack_public_path__ + "static/media/Казаков Е..9c1e2939.pdf";